export const GetUpperCase = (value) => {
    let string = '';
    if (value && value.length > 2) {
        string = `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
    }
    return string;
}